import { jsx, jsxs } from "react/jsx-runtime";
const LEVEL_COLORS = [
    'tw-bg-alert-400',
    'tw-bg-on-hold-300',
    'tw-bg-warning-400',
    'tw-bg-success-500'
];
const LABEL_COLORS = [
    'tw-cds-text-alert',
    'tw-cds-text-warning',
    'tw-cds-text-warning',
    'tw-cds-text-success'
];
const PasswordStrengthBar = ({ score, total, visible, label })=>{
    if (!visible || total < 2) return null;
    const levelIndex = score > 0 ? 4 - total + score - 1 : -1;
    const activeColor = levelIndex >= 0 ? LEVEL_COLORS[levelIndex] : '';
    const labelColor = levelIndex >= 0 ? LABEL_COLORS[levelIndex] : '';
    const segments = Array.from({
        length: total
    }, (_, i)=>({
            key: `seg-${i}`,
            active: i < score
        }));
    return /*#__PURE__*/ jsxs("div", {
        className: "tw-mt-0.8",
        children: [
            /*#__PURE__*/ jsx("div", {
                className: "tw-flex tw-gap-0.4",
                children: segments.map(({ key, active })=>/*#__PURE__*/ jsx("div", {
                        className: `tw-h-0.4 tw-flex-1 tw-rounded-0.4 ${active && activeColor ? activeColor : 'tw-cds-bg-subtle-01'}`
                    }, key))
            }),
            label && /*#__PURE__*/ jsx("p", {
                className: `tw-cds-font-label-01 tw-mt-0.4 ${labelColor}`,
                children: label
            })
        ]
    });
};
export { PasswordStrengthBar };
